import { classNames } from "../../helpers/classNames";

/**
 * Page body for the builder steps.
 *
 * Mobile and tablet: the content, with room at the bottom for `bottomBar`
 * (a `BottomBar`). Desktop: a 1200px row with the content in a white card and
 * `aside` (a `BookSidePanel`) beside it.
 *
 * Use `plain` for screens that aren't a card on desktop (My Books, Review
 * order), which only need the width and the bottom-bar padding.
 */
const WizardShell = ({ children, aside = null, bottomBar = null, plain = false, className }) => (
  <>
    <div
      className={classNames(
        "mx-auto w-full max-w-[1200px] px-4 pt-7 pb-[200px] md:px-[90px] md:pt-8 lg:px-8 lg:pt-10 lg:pb-16",
        "lg:flex lg:items-start lg:gap-8",
        className
      )}
    >
      <main
        className={classNames(
          "min-w-0 lg:flex-[999_1_560px]",
          !plain && "lg:rounded-[20px] lg:border lg:border-md-pink-light-1 lg:bg-white lg:p-12"
        )}
      >
        {children}
      </main>
      {aside ? <div className="hidden lg:block lg:max-w-[380px] lg:flex-[1_1_320px]">{aside}</div> : null}
    </div>
    {bottomBar}
  </>
);

export default WizardShell;
